// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2647":"d21056d1716a7827","2888":"5cda559862075924","7297":"d21056d1716a7827"}[chunkId] + ".css";
};